import { Injectable } from '@angular/core';


import { AuthService } from '@app/shared/services/auth.service';

@Injectable()
export class CareerMobilityAccessGuardService  {
  constructor(private authService: AuthService) {}

  public canActivate() {
    return this.authService.authUser?.hasCareerMobility;
  }
}
